import { Box, Icon, Stack, Tooltip, Typography } from "@mui/material";

interface CardInformationProps {
    title: string | JSX.Element;
    value: string | number | JSX.Element;
    info?: string;
    verticalAlignment?: boolean;
}

export default function CardInformation(props: CardInformationProps) {
    const { title, value, info, verticalAlignment = false } = props;

    if (verticalAlignment) {
        return (
            <Stack
                spacing={0.5}
                sx={{
                    width: "100%",
                }}
            >
                {info && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Tooltip title={info}>
                            <Icon color="warning">info</Icon>
                        </Tooltip>
                    </Box>
                )}
                <Typography color="text.secondary" sx={{ fontSize: 12 }}>
                    {title}
                </Typography>
                <Typography sx={{ fontSize: 12 }}>{value}</Typography>
            </Stack>
        );
    }

    return (
        <Box
            sx={{
                gap: 1,
                display: "flex",
                alignItems: "center",
                width: "100%",
            }}
        >
            {info && (
                <Tooltip title={info}>
                    <Icon color="warning">info</Icon>
                </Tooltip>
            )}
            <Typography color="text.secondary" sx={{ fontSize: 12 }}>
                {title}
            </Typography>
            <span
                style={{
                    flexGrow: 1,
                    margin: "0 16px",
                    borderBottom: "1px dashed rgba(0,0,0, 0.1)",
                }}
            ></span>
            <Typography noWrap sx={{ fontSize: 12 }}>
                {value}
            </Typography>
        </Box>
    );
}
